import React, { memo } from 'react'
import { string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const BlockBDCWhiteBgBlueText = memo(({ height = '100%', width = '100%' }) => {
	const {
		colors: { primary, secondary, white },
	} = useTheme()

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 252 85"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<path id="prefix__b" d="M59.466 0H0v61.72h9.902v15.317L27.937 61.72H224V0H59.466" />
				<path id="prefix__c" d="M0 0h224v77H0z" />
				<filter
					x="-10.7%"
					y="-23.4%"
					width="121.4%"
					height="162.3%"
					filterUnits="objectBoundingBox"
					id="prefix__a"
				>
					<feOffset dy={6} in="SourceAlpha" result="shadowOffsetOuter1" />
					<feGaussianBlur stdDeviation={7} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
					<feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
					<feColorMatrix
						values="0 0 0 0 0 0 0 0 0 0.231372549 0 0 0 0 0.360784314 0 0 0 0.0953070367 0"
						in="shadowBlurOuter1"
					/>
				</filter>
			</defs>
			<g fill="none" fillRule="evenodd">
				<g transform="translate(14 8)">
					<use fill="#000" filter="url(#prefix__a)" xlinkHref="#prefix__b" />
					<use fillOpacity={0} fill="#30FF00" xlinkHref="#prefix__b" />
				</g>
				<g transform="translate(14 8)">
					<mask id="prefix__d" fill={white}>
						<use xlinkHref="#prefix__c" />
					</mask>
					<path
						fill="#FFFFFE"
						mask="url(#prefix__d)"
						d="M59.466 0H0v61.72h9.902v15.317L27.937 61.72H224V0H59.466"
					/>
				</g>
				<path
					d="M44.55 45.483c.508.278 1.475.48 2.263.48 2.339 0 3.687-1.867 3.687-4.491 0-2.246-.992-3.558-2.899-3.558-1.958 0-3.052 1.312-3.052 3.255v4.314zm.076-16.35v5.324c0 .556 0 .985-.254 3.381h.05c.789-1.817 2.263-2.8 4.5-2.8 3.078 0 5.137 2.295 5.137 6.03 0 4.517-2.492 7.771-7.425 7.771-1.957 0-4.45-.479-5.568-1.11V31.707h-2.034v-2.574h5.594zM60.57 35.34v7.545c0 2.397.712 3.078 2.34 3.078 1.55 0 2.771-1.237 2.771-3.229v-4.82h-1.678V35.34h5.238v10.623h1.551v2.574h-4.984c0-1.514.128-2.398.331-2.726h-.05c-.84 2.12-2.29 3.028-4.603 3.028-3.102 0-4.476-1.968-4.476-4.516v-6.409h-1.78V35.34h5.34M83.61 39.176h-3.205v-1.338c-.711-.226-1.373-.377-2.06-.377-1.626 0-2.39.655-2.39 1.387 0 .933.306.958 3.891 1.439 3.153.428 4.424 1.538 4.424 3.986 0 2.8-2.237 4.566-6.28 4.566-1.5 0-3.992-.353-5.239-.832v-3.71h3.204v1.54c.61.201 1.628.428 2.365.428 1.323 0 2.594-.53 2.594-1.615 0-1.008-.738-1.185-4.831-1.765-2.467-.354-3.484-1.59-3.484-3.533 0-2.724 2.289-4.314 5.848-4.314 1.425 0 3.154.202 5.162.883v3.255M91.264 35.34v10.623h1.526v2.574h-6.535v-2.574h1.45v-8.049h-1.73V35.34h5.289M108.682 45.963h1.526v2.574h-6.535v-2.574h1.449v-5.5c0-1.64-.915-2.397-2.313-2.397-2.009 0-3.103 1.387-3.103 3.406v4.491h1.526v2.574H94.85v-2.574h1.296v-8.049h-1.729V35.34h5.213c0 .985 0 1.741-.203 2.726h.05c.687-1.74 2.263-3.028 4.603-3.028 3.179 0 4.602 2.094 4.602 5.046v5.88M120.559 40.311c0-1.792-.992-2.85-2.721-2.85-1.552 0-2.517 1.008-2.696 2.85h5.417zm-5.391 2.423c.102 2.118 1.703 3.38 4.246 3.38 1.628 0 2.72-.227 4.272-.908l-.178 2.8c-1.653.606-3.077.833-4.882.833-4.653 0-7.323-2.675-7.323-6.837 0-4.214 2.645-6.964 6.687-6.964 3.941 0 6.433 2.624 6.433 7.696h-9.255zM137.113 39.176h-3.204v-1.338c-.712-.226-1.373-.377-2.06-.377-1.627 0-2.39.655-2.39 1.387 0 .933.305.958 3.89 1.439 3.153.428 4.425 1.538 4.425 3.986 0 2.8-2.238 4.566-6.281 4.566-1.5 0-3.992-.353-5.238-.832v-3.71h3.204v1.54c.61.201 1.627.428 2.365.428 1.322 0 2.593-.53 2.593-1.615 0-1.008-.737-1.185-4.83-1.765-2.467-.354-3.484-1.59-3.484-3.533 0-2.724 2.288-4.314 5.848-4.314 1.424 0 3.153.202 5.162.883v3.255M150.565 39.176h-3.204v-1.338c-.712-.226-1.373-.377-2.06-.377-1.627 0-2.39.655-2.39 1.387 0 .933.306.958 3.89 1.439 3.154.428 4.425 1.538 4.425 3.986 0 2.8-2.237 4.566-6.28 4.566-1.5 0-3.993-.353-5.238-.832v-3.71h3.203v1.54c.61.201 1.627.428 2.365.428 1.323 0 2.594-.53 2.594-1.615 0-1.008-.737-1.185-4.832-1.765-2.466-.354-3.483-1.59-3.483-3.533 0-2.724 2.289-4.314 5.848-4.314 1.424 0 3.153.202 5.162.883v3.255M171.722 39.529h-3.051v-1.767c-.585-.125-.814-.15-1.221-.15-2.084 0-3.356 1.766-3.356 3.961 0 2.649 1.55 4.39 4.22 4.39a7.79 7.79 0 003.332-.732l-.204 2.978c-1.424.479-1.983.63-3.941.63-4.373 0-6.967-2.826-6.967-6.888 0-4.239 2.746-6.913 7.018-6.913 1.602 0 2.924.252 4.17.63v3.86M183.37 42.153c0-2.826-.916-4.239-3.154-4.239-1.83 0-3.102 1.413-3.102 4.239 0 2.397.916 3.81 3.128 3.81s3.128-1.413 3.128-3.81zm-3.128 6.686c-4.45 0-6.993-2.497-6.993-6.762 0-3.91 2.797-7.039 6.993-7.039 4.551 0 6.992 2.498 6.992 7.04 0 3.96-2.797 6.761-6.992 6.761zM202.39 38.015c.636-1.842 2.11-2.977 4.45-2.977 3.179 0 4.602 2.094 4.602 5.046v5.88h1.526v2.573h-6.382v-2.574h1.297v-5.5c0-1.64-.916-2.397-2.314-2.397-1.755 0-2.823 1.463-2.823 3.406v4.491h1.526v2.574h-6.382v-2.574h1.296v-5.5c0-1.64-.915-2.397-2.313-2.397-1.806 0-2.823 1.488-2.823 3.406v4.491h1.526v2.574h-6.535v-2.574h1.45v-8.049h-1.73V35.34h5.213c0 .934 0 1.767-.203 2.675h.05c.738-1.918 2.365-2.977 4.603-2.977 2.212 0 3.534.983 3.915 2.977h.051M91.57 30.95c0 1.212-.991 2.196-2.213 2.196a2.205 2.205 0 01-2.213-2.196c0-1.212.99-2.195 2.213-2.195 1.222 0 2.212.983 2.212 2.195"
					fill={primary}
				/>
				<path
					d="M158.27 46.695a2.28 2.28 0 01-2.288 2.27 2.28 2.28 0 01-2.288-2.27 2.28 2.28 0 012.288-2.271 2.28 2.28 0 012.288 2.27"
					fill={secondary}
				/>
			</g>
		</svg>
	)
})

BlockBDCWhiteBgBlueText.propTypes = {
	height: string,
	width: string,
}
